import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { List, X } from '@phosphor-icons/react';
import { Button } from '../components/ui/button';
import VentriqoLogo from '../components/VentriqoLogo';

export default function Navbar() {
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();

  const links = [
    { to: '/', label: 'Home' },
    { to: '/services', label: 'Services' },
    { to: '/pricing', label: 'Pricing' },
    { to: '/blog', label: 'Blog' },
    { to: '/about', label: 'About' },
    { to: '/contact', label: 'Contact' },
  ];

  const isActive = (path) => location.pathname === path;

  return (
    <nav data-testid="navbar" className="w-full bg-white border-b border-black/10 sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-6 h-16 flex items-center justify-between">
        <Link to="/" data-testid="nav-logo">
          <VentriqoLogo className="h-8 w-auto" />
        </Link>

        <div className="hidden md:flex items-center gap-8">
          {links.map(link => (
            <Link
              key={link.to}
              to={link.to}
              data-testid={`nav-link-${link.label.toLowerCase()}`}
              className={`text-sm font-medium transition-colors duration-200 ${
                isActive(link.to) ? 'text-[#002FA7]' : 'text-gray-600 hover:text-black'
              }`}
            >
              {link.label}
            </Link>
          ))}
        </div>

        <div className="hidden md:block">
          <Link to="/#lead-form">
            <Button
              data-testid="nav-cta-button"
              className="bg-[#002FA7] hover:bg-[#002277] text-white rounded-[4px] text-sm font-semibold px-6"
            >
              Get Finance Health Check
            </Button>
          </Link>
        </div>

        <button
          data-testid="mobile-menu-toggle"
          className="md:hidden text-black"
          onClick={() => setMenuOpen(!menuOpen)}
        >
          {menuOpen ? <X size={24} /> : <List size={24} />}
        </button>
      </div>

      {menuOpen && (
        <div data-testid="mobile-menu" className="md:hidden bg-white border-t border-black/10 px-6 py-4 space-y-3">
          {links.map(link => (
            <Link
              key={link.to}
              to={link.to}
              onClick={() => setMenuOpen(false)}
              className={`block text-sm font-medium ${isActive(link.to) ? 'text-[#002FA7]' : 'text-gray-600'}`}
            >
              {link.label}
            </Link>
          ))}
          <Link to="/#lead-form" onClick={() => setMenuOpen(false)}>
            <Button className="w-full bg-[#002FA7] hover:bg-[#002277] text-white rounded-[4px] text-sm font-semibold mt-2">
              Get Finance Health Check
            </Button>
          </Link>
        </div>
      )}
    </nav>
  );
}
